// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.server-name {
  font-size: x-large;
  padding: 5px;
  text-indent: 0.5em;
}

.host-name {
  padding: 5px;
  text-indent: 1em;
  font-size: large;
}

.server-name-border {
  border-color: var(--color-main);
  border-radius: 5px;
  border-width: 5px;
}

.server-border {
  border: solid;
  border-color: var(--color-main);
  border-radius: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Servers/router/screens/Index/components/ServerTable.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;AACpB","sourcesContent":[".server-name {\n  font-size: x-large;\n  padding: 5px;\n  text-indent: 0.5em;\n}\n\n.host-name {\n  padding: 5px;\n  text-indent: 1em;\n  font-size: large;\n}\n\n.server-name-border {\n  border-color: var(--color-main);\n  border-radius: 5px;\n  border-width: 5px;\n}\n\n.server-border {\n  border: solid;\n  border-color: var(--color-main);\n  border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
